import React from 'react';
import styles from './css/ArticleButton.styl';

const ArticleButton = props => {
  const handleClick = () => {
    if (window) {
      window.open(props.href);
    }
  };

  /**
   * Returns JSX representation of a ArticleButton block
   * @param {String} href article href
   * @param {Object} image image
   * @param {String} title article title
   * @returns {JSX} ArticleButton block
   */
  return (
    <div className={styles.ArticleButton} onClick={handleClick}>
      <div className={styles.IconContainer}>
        <img src={props.image} />
      </div>
      <div className={styles.TextContainer}>
        <div className={styles.ArticleTitle}>{props.title}</div>
        <div className={styles.ReadMore}>Read More</div>
      </div>
    </div>
  );
};

ArticleButton.propTypes = {
  href: React.PropTypes.string,
  image: React.PropTypes.object,
  title: React.PropTypes.string,
};

export default ArticleButton;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/ArticlesBlock/ArticleButton.js